import React from 'react';
import CafeMap from './CafeMap';
import './CafeMapPage.css';

const CafeMapPage = () => {
  return (
    <div className="cafe-map-page">
      <CafeMap />
    </div>
  );
};

export default CafeMapPage;